import React from 'react';
import { Backdrop } from '@mui/material';
import LoaderIcon from '../Assets/images/loader.svg';

  const BiztantuLoader = ({open, children, isChildren, position="fixed" }) => {
    
    return (
        <div className="biztantu-loader-container">
            <Backdrop 
                    open={open} 
                    className="biztantu-loader-backdrop"
                    sx = {{
                        zIndex: 1,
                    }}
                >
                <div>

                <img
                    src={LoaderIcon}
                    alt="loading"
                    className="biztantu-loader-image"
                />
            </div>
            </Backdrop>
            {isChildren && children}
        </div>
    )
}

export default BiztantuLoader;